import { render } from "./CaiGouShenPiPrint.vue?vue&type=template&id=b9b7fa38&scoped=true"
import script from "./CaiGouShenPiPrint.vue?vue&type=script&lang=js"
export * from "./CaiGouShenPiPrint.vue?vue&type=script&lang=js"

import "./CaiGouShenPiPrint.vue?vue&type=style&index=0&id=b9b7fa38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b7fa38"]])

export default __exports__